var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncomeDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2962_5567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 33C28.0751 33 33 28.0751 33 22C33 15.9249 28.0751 11 22 11C15.9249 11 11 15.9249 11 22C11 28.0751 15.9249 33 22 33Z",
    fill: "#667080"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2962_5567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 23.583L23.125 20.333",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1458 20.8747C20.2954 20.8747 20.4167 20.7534 20.4167 20.6038C20.4167 20.4543 20.2954 20.333 20.1458 20.333C19.9963 20.333 19.875 20.4543 19.875 20.6038C19.875 20.7534 19.9963 20.8747 20.1458 20.8747Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8543 23.5837C23.0039 23.5837 23.1252 23.4624 23.1252 23.3128C23.1252 23.1632 23.0039 23.042 22.8543 23.042C22.7048 23.042 22.5835 23.1632 22.5835 23.3128C22.5835 23.4624 22.7048 23.5837 22.8543 23.5837Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7085 27.375V18.7083C17.7085 18.421 17.8226 18.1455 18.0258 17.9423C18.229 17.7391 18.5045 17.625 18.7918 17.625H24.2085C24.4958 17.625 24.7714 17.7391 24.9745 17.9423C25.1777 18.1455 25.2918 18.421 25.2918 18.7083V27.375L23.6668 26.2917L22.5835 27.375L21.5002 26.2917L20.4168 27.375L19.3335 26.2917L17.7085 27.375Z",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2962_5567",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.6 0 0 0 0 0.705882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2962_5567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2962_5567",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2962_5567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeDetails);
export default __webpack_public_path__ + "static/media/income_details.f857455d8cc9e0685c4fb62cbe861890.svg";
export { ForwardRef as ReactComponent };